import { render } from "./debitor-receipt.vue?vue&type=template&id=68361bca&scoped=true"
import script from "./debitor-receipt.vue?vue&type=script&lang=js"
export * from "./debitor-receipt.vue?vue&type=script&lang=js"

import "./debitor-receipt.vue?vue&type=style&index=0&id=68361bca&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68361bca"]])

export default __exports__